export default __webpack_public_path__ + "static/010a-6e5c4253dd590c64ab8d08f5447122c3.jpg";